"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameVendorSettings = void 0;
const react_redux_1 = require("react-redux");
const GameVendorSettingsProvider_1 = require("../containers/GameVendorSettingsProvider");
// Will be deprecated: Use selectGameVendorSettingsStatus for more precise control
const useGameVendorSettings = (page) => {
    const vendors = (0, react_redux_1.useSelector)(GameVendorSettingsProvider_1.selectGameVendorSettings);
    const fetchItems = (0, react_redux_1.useSelector)(GameVendorSettingsProvider_1.selectGameVendorSettingsFetchItems);
    return fetchItems.loading || vendors[page];
};
exports.useGameVendorSettings = useGameVendorSettings;
//# sourceMappingURL=useGameVendorSettings.js.map